import { render } from "./AnnuaireAgenceView.vue?vue&type=template&id=b5851ab2"
import script from "./AnnuaireAgenceView.vue?vue&type=script&lang=js"
export * from "./AnnuaireAgenceView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__